import { render, staticRenderFns } from "./ApplicantOnboardingSyntage.vue?vue&type=template&id=2937b5db&"
import script from "./ApplicantOnboardingSyntage.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingSyntage.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantOnboardingSyntage.vue?vue&type=style&index=0&id=2937b5db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports